import { render, staticRenderFns } from "./EditFormTemplate.vue?vue&type=template&id=72118d63&scoped=true"
import script from "./EditFormTemplate.vue?vue&type=script&lang=js"
export * from "./EditFormTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditFormTemplate.vue?vue&type=style&index=0&id=72118d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72118d63",
  null
  
)

export default component.exports